<!-- eslint-disable max-len -->
<template>
  <div class="about-project_apt" :class="{ [curTheme]: true }">

    <page-header>
      <h1>Ошибка 403: отказано в доступе</h1>
    </page-header>

    <page-text>
      <div class="text-center" style="max-width: 600px; margin: 0 auto 100px;">
        <p style="margin: 100px 0 60px;">У вас нет доступа до указаной страницы. Возможно вам требуется войти на сайт, чтобы получить необходимый уровень доступа.</p>
        <el-button class="vivid-button" @click="$router.replace({ path: '/user/authenticate' })">Войти</el-button>
      </div>
    </page-text>

    <page-footer/>
  </div>
</template>

<script>
import PageHeader from '../PageHeader';
import PageText from '../PageText';
import PageFooter from '../PageFooter';

export default {
  components: { PageHeader, PageText, PageFooter },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/layouts/Page403.vue